// extracted by mini-css-extract-plugin
export default {"blockList":"T4imS"};